<template>
  <div id="app">
    <Navbar></Navbar>
    <section>
      <transition >
        <keep-alive :include="cachedViews">
          <router-view />
        </keep-alive>
      </transition>
    </section>

  </div>
</template>
<style lang="scss">
@import 'assets/css/css.scss';
</style>
<script  >
import Navbar from "@/components/Navbar/navbar.vue";
import router from "@/router";
export default {
  components: {
    Navbar
  },
  computed:{
    cachedViews() {
      return router.options.routes.filter(v=>v.meta && v.meta.keepAlive).map(v=>v.name)
    },
  }
}
</script>
